export enum ImageTuningLimitType {
  Lower,
  Upper,
}
